export default {
  text: {
    en: `
    Don't worry: once you join our club,
    change your {isCream, plural, one {cream} other {scent}}
    and add others at ANY TIME!
  `,
  },
  linkButtonTitle: {
    en: 'More info',
  },
  rateCountText: {
    en: '{rateCount, plural, one {# review} other {# reviews}}',
  },
}
